import store from '../store'

class API {
  constructor () {
    this.state = store.getState().siteReducer
    store.subscribe(() => {
      this.state = store.getState().siteReducer
    })
  }
  async _make (endpoint, query, wrapper, suppressError) {
    var start = Date.now()
    return new Promise((resolve, reject) => {
      this.state.deepstream.rpc.make(endpoint, {...query, token: this.state.token}, (error, response) => {
        var now = Date.now()
        console.log('%c Firing RPC ' + endpoint + '', 'background: #222; color: #bada55')
        console.log('Query: ', query)
        console.log('Start: ', start, 'Now: ', now, 'Time: ', now - start, 'ms')
        if (error && !suppressError) {
          console.log('ERROR')
          console.log(error)
          console.log(endpoint, error, query)
          store.dispatch({
            type: 'ALERT_CREATE',
            payload: {
              title: error,
              type: 'error',
              text: 'The server is currently unavailable, try again later. \b' + 'ENDPOINT:' + endpoint
            }
          })
          return reject(error)
        }
        if (response && response.count) console.log('Count: ', response.count)
        console.log('RESPONSE: ', response)
        if (wrapper) resolve({...wrapper, ...response})
        resolve(response)
      })
    })
  }
  async make (endpoint, query, wrapper, suppressError) {
    query = query || {}

    if (query.data && query.data.attributes) {
      let entries = Object.entries(query.data.attributes)
      for (let i = 0; i < entries.length; i++) {
        if (query.data.attributes[entries[i][0]] && query.data.attributes[entries[i][0]].hasOwnProperty('value') && (query.data.attributes[entries[i][0]].value !== true && query.data.attributes[entries[i][0]].value !== false && !query.data.attributes[entries[i][0]].value.length) && !query.data.attributes[entries[i][0]].writeEmpty) {
          delete query.data.attributes[entries[i][0]]
        } else if (query.data.attributes[entries[i][0]] && query.data.attributes[entries[i][0]].hasOwnProperty('value')) {
          query.data.attributes[entries[i][0]] = query.data.attributes[entries[i][0]].value
        }
      }
      return this._make(endpoint, query, wrapper, suppressError)
    }
    return this._make(endpoint, query, wrapper, suppressError)
  }
  update (endpoint, query, suppressError) {
    return this.make(endpoint, {method: 'UPDATE', ...query}, null, suppressError)
  }
  open (endpoint, query, suppressError) {
    if (typeof query === 'string') return this.make(endpoint, {method: 'OPEN', objectid: query}, null, suppressError)
    return this.make(endpoint, {method: 'OPEN', ...query}, null, suppressError)
  }
  list (endpoint, query, suppressError) {
    return this.make(endpoint, {method: 'LIST', ...query}, null, suppressError)
  }
  create (endpoint, query, suppressError) {
    return this.make(endpoint, {method: 'CREATE', ...query}, null, suppressError)
  }
  delete (endpoint, query, suppressError) {
    return this.make(endpoint, {method: 'DELETE', ...query}, null, suppressError)
  }
  index (endpoint, query, suppressError) {
    return this.make(endpoint, {method: 'INDEX', ...query}, null, suppressError)
  }
  run (endpoint, query, suppressError) {
    return this.make(endpoint, {method: 'RUN', ...query}, null, suppressError)
  }
  multi (requests) {
    return Promise.all(requests)
  }
  dispatch (object) {
    Object.keys(object).map(key => {
      store.dispatch({
        type: key,
        payload: object[key]
      })
    })
  }
}
export default new API()



// WEBPACK FOOTER //
// ./src/API/index.js